import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

const CartBadge = ({ onClick }) => {
  const itemCount = useSelector((state) => state.cart.item_count || 0);
  const status = useSelector((state) => state.cart.status);
  const badgeCount = status === "submitted" ? 0 : itemCount;

  return (
    <Link
      to="/cart"
      onClick={onClick}
      className="relative inline-flex items-center gap-2 rounded-full border border-transparent px-3 py-1.5 text-sm font-semibold text-blue-600 hover:text-blue-700 dark:text-blue-300 dark:hover:text-blue-200"
      aria-label="View cart"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
        className="h-6 w-6"
        aria-hidden="true"
      >
        <path d="M7 4h-2a1 1 0 100 2h1.278l1.518 7.588A3 3 0 0010.717 16h6.566a3 3 0 002.95-2.434l1.09-5.451A1 1 0 0020.35 7H8.239l-.277-1.389A1 1 0 007 4zm3 16a2 2 0 11-4 0 2 2 0 014 0zm10 0a2 2 0 11-4 0 2 2 0 014 0z" />
      </svg>
      <span className="hidden sm:inline">Cart</span>
      {badgeCount > 0 && (
        <span className="absolute -top-1 -right-1 inline-flex h-5 min-w-[1.25rem] items-center justify-center rounded-full bg-red-600 px-1 text-xs font-bold text-white">
          {badgeCount}
        </span>
      )}
    </Link>
  );
};

export default CartBadge;
